import { render } from "./SmokeInducedSickness.vue?vue&type=template&id=b55c2672&scoped=true"
import script from "./SmokeInducedSickness.vue?vue&type=script&lang=js"
export * from "./SmokeInducedSickness.vue?vue&type=script&lang=js"

import "./SmokeInducedSickness.vue?vue&type=style&index=0&id=b55c2672&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b55c2672"]])

export default __exports__